// extracted by mini-css-extract-plugin
module.exports = {"textareaContainer":"styles_textareaContainer__1SvNs","label":"styles_label__Dr7z7","textarea":"styles_textarea__1Fm_X","error":"styles_error__3NKKz","hint":"styles_hint__3aRTt"};